var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12505 19.0999L0.700049 10.6999C0.600049 10.5999 0.529382 10.4916 0.488049 10.3749C0.446049 10.2582 0.425049 10.1332 0.425049 9.9999C0.425049 9.86657 0.446049 9.74157 0.488049 9.6249C0.529382 9.50824 0.600049 9.3999 0.700049 9.2999L9.12505 0.874902C9.35838 0.641569 9.65005 0.524902 10 0.524902C10.35 0.524902 10.65 0.649902 10.9 0.899902C11.15 1.1499 11.275 1.44157 11.275 1.7749C11.275 2.10824 11.15 2.3999 10.9 2.6499L3.55005 9.9999L10.9 17.3499C11.1334 17.5832 11.25 17.8706 11.25 18.2119C11.25 18.5539 11.125 18.8499 10.875 19.0999C10.625 19.3499 10.3334 19.4749 10 19.4749C9.66672 19.4749 9.37505 19.3499 9.12505 19.0999V19.0999Z",
    fill: "#999999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowRight.396145160e0f78e6fe8b1936f1b5c8d0.svg";